// Shared helpers for threading `?service=` through URLs — used by detail / list
// / settings pages that need shareable, deep-link-safe URLs for shared-slug
// objects across services.

// Stamp `?service=<service>` into the address bar via replaceState (no nav).
// No-op if the URL already has ?service= or service is falsy.
export const canonicalizeServiceInUrl = (service) => {
  if (!service || typeof window === "undefined") return;
  const url = new URL(window.location);
  if (url.searchParams.get("service")) return;
  url.searchParams.set("service", service);
  window.history.replaceState({}, "", url.toString());
};

// Append ?service=... or &service=... to a path, preserving any existing query.
export const withServiceQuery = (path, service) => {
  if (!service) return path;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}service=${encodeURIComponent(service)}`;
};
